export const MONEY = new Intl.NumberFormat("ru-RU", {
  style: "currency",
  currency: "RUB",
  maximumFractionDigits: 2,
});

const MONTH_LABEL = new Intl.DateTimeFormat("ru-RU", {
  month: "long",
  year: "numeric",
});

const MONTH_SHORT = new Intl.DateTimeFormat("ru-RU", {
  month: "short",
  year: "numeric",
});

export const OWNERS = [
  { value: "firm", label: "Фирма" },
  { value: "lina", label: "Лина" },
  { value: "vitaliy", label: "Виталий" },
];

export const LIABILITY_OWNERS = OWNERS.filter((o) => o.value !== "firm");

export const ROLES = [
  { value: "payroll", label: "ЗП" },
  { value: "credit", label: "Кредиты" },
  { value: "tax", label: "Налоги" },
  { value: "vacation", label: "Отпуск" },
  { value: "software", label: "Программы" },
];

export const RECURRENCES = [
  { value: "once", label: "Разово" },
  { value: "monthly", label: "Ежемесячно" },
  { value: "quarterly", label: "Ежеквартально" },
  { value: "yearly", label: "Ежегодно" },
];

export const SPHERES = [
  { value: "personal", label: "Личное" },
  { value: "business", label: "Фирма" },
];

export function currentMonthIso() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
}

export function shiftMonth(month, delta) {
  const [year, monthNum] = String(month).split("-").map(Number);
  const date = new Date(year, monthNum - 1 + delta, 1);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
}

export function formatMonthLabel(month) {
  const [year, monthNum] = String(month).split("-").map(Number);
  if (!year || !monthNum) return month;
  return MONTH_LABEL.format(new Date(year, monthNum - 1, 1));
}

export function formatMonthShort(month) {
  const [year, monthNum] = String(month).split("-").map(Number);
  if (!year || !monthNum) return month;
  return MONTH_SHORT.format(new Date(year, monthNum - 1, 1))
    .replace(/\s*г\.?\s*$/u, "")
    .replace(/\./g, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function formatMoney(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return "—";
  return MONEY.format(num);
}

export function formatPct(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return "—";
  return String(num).replace(".", ",");
}

export function parseAmount(raw) {
  const trimmed = String(raw ?? "").trim().replace(/\s/g, "").replace(",", ".");
  if (!trimmed) return { ok: false };
  const num = Number(trimmed);
  if (!Number.isFinite(num)) return { ok: false };
  return { ok: true, value: num };
}

export function rateToPctInput(rate) {
  if (rate == null || rate === "") return "";
  const num = Number(rate) * 100;
  if (!Number.isFinite(num)) return "";
  return String(Number(num.toFixed(4)));
}

export function pctInputToRate(raw) {
  const parsed = parseAmount(raw);
  if (!parsed.ok) return { ok: false };
  return { ok: true, value: Number((parsed.value / 100).toFixed(4)) };
}

function labelOf(items, value) {
  return items.find((item) => item.value === value)?.label || value;
}

export function ownerLabel(owner) {
  return labelOf(OWNERS, owner);
}

export function roleLabel(role) {
  return labelOf(ROLES, role);
}

export function recurrenceLabel(recurrence) {
  return labelOf(RECURRENCES, recurrence);
}

export function sphereLabel(sphere) {
  return labelOf(SPHERES, sphere);
}

export function accountTitle(accounts, id) {
  if (id == null || id === "") return "—";
  const found = (accounts || []).find((item) => String(item.id) === String(id));
  return found?.title || "—";
}

export function normalizeBankName(raw) {
  if (raw == null || raw === "") return null;
  const normalized = String(raw)
    .trim()
    .toLowerCase()
    .replace(/ё/g, "е")
    .split(/\s+/)
    .filter(Boolean)
    .join(" ");
  if (normalized === "") return null;
  return normalized;
}

export function expectsBankSlots(account) {
  if (account == null) return false;
  if (account.kind === "fund" && account.owner === "firm") return true;
  return (
    account.kind === "account"
    && account.owner === "firm"
    && normalizeBankName(account.title) === "расчетный"
  );
}

export function bankClosedLabel(ownerLabel, tail) {
  return `${ownerLabel} · …${tail}`;
}
